import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { InboxList } from '@/components/InboxList';

const inboxSearchSchema = z.object({
  tab: z.enum(['notices', 'activity']).optional().default('notices'),
});

export const Route = createFileRoute('/_auth/inbox/')({
  component: InboxRoute,
  validateSearch: inboxSearchSchema,
});

function InboxRoute() {
  const { tab } = Route.useSearch();
  return <InboxList tab={tab} />;
}
